export default "__VITE_ASSET__058QQQ2$__"